<span class="notranslate">{{ currency }}</span>
